<router-outlet></router-outlet>

<maplix-cookie-consent [cookieDomain]="cookieDomain"></maplix-cookie-consent>
